(function()
{
	"use strict";

	function FlashAnimationLoader(loadItem, preferXHR)
	{
		this.AbstractLoader_constructor(loadItem, preferXHR, "flash_animation");
		this._manifestQueue = null;
	}

	var p = createjs.extend(FlashAnimationLoader, createjs.AbstractLoader);
	var s = FlashAnimationLoader;
	s.MANIFEST_PROGRESS = 0.25;

	s.canLoadItem = function(item)
	{
		return item.type === "flash_animation";
	};

	// public methods
	p.destroy = function()
	{
		this.AbstractLoader_destroy();
		this._manifestQueue.close();
	};

	// protected methods
	p._createRequest = function()
	{
		this._request = new createjs.JavaScriptLoader(this._item);
	};

	p.handleEvent = function(event)
	{
		switch (event.type)
		{
			case "complete":
				this._rawResult = event.target.getResult(true);
				if(!AdobeAn.compositions) throw("Using out of date flash export! " + this._item.src);

				//This is an automatic composition ID retrieval, may want to eventually require manual entry
				var compId = Object.keys(AdobeAn.compositions)[0];
				//Get Composition
				var comp = this._item.comp = AdobeAn.compositions[compId];
				var lib = this._result = this._item.lib = comp.getLibrary();

				//Clean up. This is mostly because of the auto retrieval
				delete AdobeAn.compositions[compId];
				AdobeAn.compositions = null;

				if (!lib) {
					throw ("Something went wrong. Lib not found");
				}

				this._sendProgress(s.MANIFEST_PROGRESS);
				this._loadManifest(lib);
				return;
			case "progress":
				event.loaded *= s.MANIFEST_PROGRESS;
				this.progress = event.loaded / event.total;
				if (isNaN(this.progress) || this.progress == Infinity)
				{
					this.progress = 0;
				}
				this._sendProgress(event);
				return;
		}
		this.AbstractLoader_handleEvent(event);
	};

	p._loadManifest = function(lib)
	{
		if (lib.properties.manifest && lib.properties.manifest.length) {
			var queue = this._manifestQueue = new createjs.LoadQueue(this._preferXHR, this._item.assetsPath, this._item.crossOrigin);
			queue.installPlugin(cjs.Sound);
			queue.on("complete", this._handleManifestComplete, this, true);
			queue.on("fileload", this._handleManifestFileLoad, this);
			queue.on("progress", this._handleManifestProgress, this);
			queue.on("error", this._handleManifestError, this, true);
			queue.loadManifest(lib.properties.manifest);
		} else {
			this._sendComplete();
		}
	};

	p._handleManifestFileLoad = function(e)
	{
		if (e && (e.item.type === "image"))
		{
			var comp = this._item.comp;
			var images = comp.getImages();
			images[e.item.id] = e.result;
		}
	};

	p._handleManifestComplete = function(e)
	{
		var comp = this._item.comp;
		var lib = comp.getLibrary();
		var ss = comp.getSpriteSheet();
		var queue = e.target;
		var ssMetadata = lib.ssMetadata;
		for(var i = 0; i < ssMetadata.length; i++) {
			ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} );
		}

		this._sendComplete();
	};

	p._handleManifestProgress = function(event)
	{
		this.progress = event.progress * (1 - s.MANIFEST_PROGRESS) + s.MANIFEST_PROGRESS;
		this._sendProgress(this.progress);
	};

	p._handleManifestError = function(event)
	{
		var newEvent = new createjs.Event("fileerror");
		newEvent.item = event.data;
		this.dispatchEvent(newEvent);
	};

	createjs.FlashAnimationLoader = createjs.promote(FlashAnimationLoader, "AbstractLoader");
})();